import {Injectable} from "@angular/core";

@Injectable({providedIn: 'root'})
export class LibEnvironmentService {
  private environment: any;

  constructor() {
  }
  setEnvironment(environment: any) {
    this.environment = environment;
  }

  getEnvironment() {
    return this.environment;
  }

}
